var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9593 10.2926C13.5757 9.68072 14.0517 9.07265 14.3627 8.63659C14.5653 8.35239 14.6667 8.21025 14.6667 7.99992C14.6667 7.78959 14.5653 7.64745 14.3627 7.36325C13.4519 6.08621 11.1261 3.33325 8 3.33325C7.3948 3.33325 6.8196 3.43643 6.27884 3.6121M4.49827 4.4982C3.15411 5.40472 2.16143 6.62836 1.63735 7.36325C1.43467 7.64745 1.33333 7.78959 1.33333 7.99992C1.33333 8.21025 1.43467 8.35239 1.63735 8.63659C2.54806 9.91365 4.87385 12.6666 8 12.6666C9.3272 12.6666 10.5101 12.1704 11.5017 11.5017",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57191 6.66675C6.21855 7.02008 6 7.50828 6 8.04748C6 9.12588 6.8742 10.0001 7.9526 10.0001C8.4918 10.0001 8.98 9.78155 9.33333 9.42815",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L14 14",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewOff);
export default __webpack_public_path__ + "static/media/view-off.d5eac4c9c20d4b2770a0eb5dad5d320b.svg";
export { ForwardRef as ReactComponent };